var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinimizeScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1D2939"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1675_673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1004 14.6H22.3004C22.7204 14.6 23.0004 14.32 23.0004 13.9C23.0004 13.48 22.7204 13.2 22.3004 13.2H19.7804L22.7904 10.19C23.0704 9.91 23.0704 9.49 22.7904 9.21C22.5104 8.93 22.0904 8.93 21.8104 9.21L18.8004 12.22V9.7C18.8004 9.28 18.5204 9 18.1004 9C17.6804 9 17.4004 9.28 17.4004 9.7V13.9C17.4004 14.32 17.6804 14.6 18.1004 14.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9 9C13.48 9 13.2 9.28 13.2 9.7V12.22L10.19 9.21C9.91 8.93 9.49 8.93 9.21 9.21C8.93 9.49 8.93 9.91 9.21 10.19L12.22 13.2H9.7C9.28 13.2 9 13.48 9 13.9C9 14.32 9.28 14.6 9.7 14.6H13.9C14.32 14.6 14.6 14.32 14.6 13.9V9.7C14.6 9.28 14.32 9 13.9 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0004 18.0999C23.0004 17.6799 22.7204 17.3999 22.3004 17.3999H18.1004C17.6804 17.3999 17.4004 17.6799 17.4004 18.0999V22.2999C17.4004 22.7199 17.6804 22.9999 18.1004 22.9999C18.5204 22.9999 18.8004 22.7199 18.8004 22.2999V19.7799L21.8104 22.7899C21.9504 22.9299 22.1604 22.9999 22.3004 22.9999C22.4404 22.9999 22.6504 22.9299 22.7904 22.7899C23.0704 22.5099 23.0704 22.0899 22.7904 21.8099L19.7804 18.7999H22.3004C22.7204 18.7999 23.0004 18.5199 23.0004 18.0999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9 17.3999H9.7C9.28 17.3999 9 17.6799 9 18.0999C9 18.5199 9.28 18.7999 9.7 18.7999H12.22L9.21 21.8099C8.93 22.0899 8.93 22.5099 9.21 22.7899C9.35 22.9299 9.49 22.9999 9.7 22.9999C9.91 22.9999 10.05 22.9299 10.19 22.7899L13.2 19.7799V22.2999C13.2 22.7199 13.48 22.9999 13.9 22.9999C14.32 22.9999 14.6 22.7199 14.6 22.2999V18.0999C14.6 17.6799 14.32 17.3999 13.9 17.3999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1675_673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizeScreen);
export default __webpack_public_path__ + "static/media/minimize-screen.cd1bcd2f.svg";
export { ForwardRef as ReactComponent };